import React from "react";
import { Box } from "@mui/material";
import MortgageCalculatorModern from "../../components/calculator/MortgageCalculatorModern";

const BorrowerMortgageCalculator = () => {
  return (
    <Box sx={{ p: { xs: 1, md: 2 } }}>
      <MortgageCalculatorModern />
    </Box>
  );
};

export default BorrowerMortgageCalculator;
